<script>
import { gtag, fbq } from '@/site/analytics/trackers'
import gtagUtils from '@/site/shop/googleAnalyticsUtils.js'
import fbPixelUtils from '@/site/shop/fbPixelUtils.js'

export default {
	lang: 'shop',
	data() {
		return {
			order: null,
			loading: true,
			cardLinkLoading: false,
		}
	},
	pageView() {
		let url = this.$router.resolve({
			name: this.$route.name,
			params: {
				...this.$route.params,
				id: '__ID__',
			},
			query: this.$route.query,
		}).href
		return {
			location: url,
		}
	},
	computed: {
		isPaid() {
			return this.order?.paymentStatus == 'paid'
		},
		canPay() {
			return this.order?.mainStatus == 'confirmed' && this.order?.paymentStatus == 'pending'
		},
	},
	methods: {
		async loadOrder() {
			await this.$shopApi.get({
				url: `/user/order/${this.$route.params.id}`,
				loading: (v) => (this.loading = v),
				onSuccess: ({ data, options }) => {
					if (!data.order) {
						options.abort()
						this.$router.replace({ name: 'user.orders' })
						return
					}
					this.order = data.order
				},
			})
		},
		async trackPurchase() {
			if (!this.order) return
			if (this.order.paymentStatus != 'paid') return
			let res = await this.$shopApi.post({
				url: `/order/${this.order.id}/purchase-tracking`,
				loading: false,
			})
			let shouldTrack = !!res?.data?.shouldTrack
			if (!shouldTrack) return

			let gtagPromise = new Promise((resolve) => {
				if (!this.$srv('Analytics.gaId')) return resolve()
				try {
					let params = gtagUtils.normalizeOrderData(this.order)
					params.event_callback = resolve
					gtag('event', 'purchase', params)
					setTimeout(resolve, 1000)
				} catch (err) {
					resolve()
				}
			})

			let fbqPromise = new Promise((resolve) => {
				if (!this.$srv('Analytics.fbpId')) return resolve()
				try {
					Promise.race([
						fbPixelUtils.triggerDoubleEvent('Purchase', fbPixelUtils.normalizeOrderData(this.order)),
						new Promise((resolve) => setTimeout(resolve, 1000)),
					])
						.then(resolve)
						.catch(() => resolve())
				} catch (err) {
					resolve()
				}
			})

			await Promise.all([gtagPromise, fbqPromise])
			await this.$shopApi.post({
				url: `/order/${this.order.id}/purchase-tracked`,
				loading: false,
			})
		},
	},
	async mounted() {
		await this.loadOrder()
		await this.trackPurchase()
	},
}
</script>

<template>
	<UserpanelLayout :title="$lang('Detalle de la compra')">
		<div v-if="loading" class="d-flex align-center justify-center py-16">
			<v-progress-circular size="50" indeterminate />
			<div class="ml-4">{{ 'Cargando el detalle de la compra' | lang }}</div>
		</div>
		<template v-else>
			<v-row>
				<v-col cols="12">
					<OrderListCard :order="order" />
				</v-col>
				<v-col cols="12" v-if="canPay">
					<PaymentInstructions :order="order" />
				</v-col>
				<v-col cols="12">
					<CheckoutConfirmCard-payment :order="order" />
				</v-col>
				<v-col cols="12" v-if="isPaid">
					<OrderDigitalItemsCard :order="order" />
				</v-col>
				<v-col cols="12" v-if="order.delivery">
					<CheckoutConfirmCard-delivery :order="order" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="5">
					<v-row>
						<v-col cols="12">
							<CheckoutConfirmCard-discount :order="order" />
						</v-col>
						<v-col cols="12">
							<CheckoutConfirmCard-contact :order="order" />
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" md="7">
					<OrderSummary :order="order" />
				</v-col>
			</v-row>
		</template>
	</UserpanelLayout>
</template>

<style></style>
